import React from "react";
import {View, Text, StyleSheet, TextInput , BackHandler} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import ExamImage from "../Components/ExamImage";
import Examvideo from "../Components/Examvideo";
import Examtext from "../Components/Examtext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Config from "../../Config";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";

const Exam = ({navigation,route})=>{






    let [data, setData] = React.useState(false);


    let [number, setNumber] = React.useState(1);

    let [results, setResults] = React.useState([]);

    let[total, setTotal] = React.useState(10);

    let percent = number*100 / total;








    React.useEffect(() => {
        getData();
    },[route.params.course_id]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/repeatcategory/${route.params.category_id}`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);
            setTotal(res.data.questions.length);



        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    if(number > total){
        navigation.navigate('Home', {
            screen: 'Tamrin',
            params: { myParam: 'Hello, Tamirn!' },
        });
    }


    return (
        <View style={styles.container}>
            {data ?
                <>
                    <View style={styles.header}>
                        <View style={styles.slider}>
                            <View style={{
                                height : RFValue(10),
                                backgroundColor : '#33B300',
                                width: `${percent}%`,
                                borderRadius : RFValue(20),
                            }}></View>
                        </View>
                        <Text style={styles.slidertxt}>{number}/{total}</Text>
                    </View>
                    <View style={styles.body}>

                        {data.questions.map( (item,index)=>
                            <>
                                {(index + 1) == number &&
                                    <>
                                        {item.awnser_type === 1 &&
                                            <>
                                                {item.type === 1 ?
                                                    <ExamImage question={item} setNumber={setNumber} setResults={setResults} />
                                                    :
                                                    <Examvideo  question={item} setNumber={setNumber} setResults={setResults} />
                                                }
                                            </>
                                        }
                                        {item.awnser_type === 2 &&
                                            <Examtext  question={item} setNumber={setNumber} setResults={setResults}/>
                                        }
                                    </>

                                }
                            </>


                        )}


                        {/*<Examvideo/>*/}
                        {/*<Examtext/>*/}


                        {/*<Text> {JSON.stringify(results)}</Text>*/}
                    </View>
                </>
                :
                <Loading/>

            }


        </View>
    );
}

const styles = StyleSheet.create({

    body : {
        flex: 1,
        paddingVertical: RFValue(5),
        paddingHorizontal: RFValue(20),
    },
    container:{
        flex : 1,
        backgroundColor:'#FAFAFA',
    },
    slidertxt : {
        fontFamily : 'yk',
        fontSize : RFValue('16'),
    },
    header : {
        flexDirection: 'row',
        justifyContent:'space-between',
        alignItems:'center',
        paddingVertical: RFValue(10),
        paddingHorizontal: RFValue(20),
    },
    slider : {
        height : RFValue(10),
        backgroundColor : '#E7E7E7',
        width: '85%',
        borderRadius : RFValue(20),
    },

});

export default Exam;